import React, { useEffect, useState } from "react";
import {
  Container,
  Row,
  Col,
  Card,
  CardBody,
  Badge,
  Button,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Alert,
} from "reactstrap";
import {
  listBackups,
  getBackupDownloadURL,
} from "../../Firebase/firebaseStorage";

import { firestore } from "../../Firebase/firebaseConfig";
import { keyBare } from "../../helpers/keyBare";
import {
  collection,
  getDocs,
  deleteDoc,
  getDoc,
  doc,
} from "firebase/firestore";

import { connect } from "react-redux";

//Import Breadcrumb
import Breadcrumbs from "../../components/Common/Breadcrumb";

// Función para formatear la fecha
const formatDate = (filename) => {
  const dateMatch = filename.match(/\d{4}-\d{2}-\d{2}/);
  if (dateMatch) {
    const [year, month, day] = dateMatch[0].split("-");
    return `${day}/${month}/${year}`;
  }
  return "N/A";
};

const Backups = (props) => {
  document.title = "Cuentas | TicketControl - Admin";

  const [backups, setBackups] = useState([]);
  const [downloadURL, setDownloadURL] = useState("");

  //  PARA TRANSLADO
  // Se conserva porque la pantalla lo usa para ocultar el botón de traslado. Lo que
  // cambió es QUIÉN lo escribe: antes lo ponía en true `BannearPC` (ya eliminada);
  // ahora lo escribe la consulta real de baneo, que es lo que debería haber sido
  // siempre — el botón tiene que esconderse si la cuenta está baneada, sin importar
  // quién la baneó ni cuándo.
  const [banned, setBanned] = useState(false);
  const company_id = props.company_id;
  const company_name = props.currentCompany.name;
  const [modal, setModal] = useState(false);
  const [modalConfirm, setModalConfirm] = useState(false);
  const [code, setCode] = useState("");
  const toggle = () => setModal(!modal);
  const toggleConfirm = () => setModalConfirm(!modalConfirm);
  const [backdrop, setBackdrop] = useState(true);
  const [keyboard, setKeyboard] = useState(true);
  const [selectedBackup, setSelectedBackup] = useState(null);
  const [licence, setLicence] = useState(null);

  // STORAGE
  useEffect(() => {
    const fetchBackups = async () => {
      try {
        const backupList = await listBackups(props.company_id);
        setBackups(backupList);
      } catch (error) {
        console.error("Error fetching backups:", error);
      }
    };

    if (props.company_id) {
      fetchBackups();
    } else {
      setBackups([]);
    }

  }, [props.company_id]);

  const getLicence = async (company_id) => {
      try {
          const ref = doc(firestore, "users", company_id);
          const snap = await getDoc(ref);
      if (!snap.exists()) return null;
      const data = snap.data();
      // "licence" es un objeto anidado en el doc
      const licence = data?.licence ?? null;
      // Opcional: normalizá por si falta algo
      // const { key, status, untildate, diffDays, error } = licence || {};
      return licence;
    } catch (err) {
      console.error("Error obteniendo licence:", err);
      return null;
    }
  };

  useEffect(() => {
    const fetchLicence = async () => {
      if (company_id) {
        const lic = await getLicence(company_id);
        setLicence(lic); // guardás en un useState
      }
    };

    fetchLicence();
  }, [company_id]);

  const downloadBackup = async (fileName) => {
    try {
      const url = await getBackupDownloadURL(props.company_id, fileName);
      setDownloadURL(url);
      // Crear un elemento <a> y simular un clic para descargar el archivo con el nombre modificado
      const link = document.createElement("a");
      link.href = url;
      link.download = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    } catch (error) {
      console.error("Error getting download URL:", error);
    }
  };

  //   const copyLink = async (fileName) => {
  //     const url = await getBackupDownloadURL(props.company_id, fileName);
  //     navigator.clipboard
  //       .writeText(url)
  //       .then(() => {
  //         alert("Enlace copiado al portapapeles");
  //       })
  //       .catch((error) => {
  //         console.error("Error al copiar el enlace:", error);
  //       });
  //   };

  // TRANSLATE TO PC

  const translateToPC_init = (backup) => {
    if (backup) {
      toggle();
      setSelectedBackup(backup);
    }
  };

  const translateToPC = async () => {
    toggle();

    // OJO: acá había un `const banned` DENTRO del try, así que quedaba encerrado en ese
    // bloque y el `if (banned)` de abajo terminaba leyendo el estado de React —que
    // arrancaba en false— en vez del resultado de la consulta. O sea que esta
    // verificación nunca frenó nada: una cuenta baneada podía iniciar un traslado igual.
    let estaBaneada;
    try {
      estaBaneada = await checkIfBanned(company_id);
    } catch (error) {
      alert("Ha ocurrido un error. Inténtalo nuevamente.");
      return;
    }

    setBanned(estaBaneada);
    if (estaBaneada) {
      alert("La cuenta está baneada");
      return;
    }

    // BANEAMOS LA CUENTA ACTUAL

    try {
      const url = await getBackupDownloadURL(licence.key, selectedBackup);


      if (!url) {
        alert("No se pudo obtener la URL de descarga");
        return;
      }

      const data = {
        file: url,
        key: company_id,
        license: JSON.stringify(licence),
      };


      const response = await fetch(
        `https://us-central1-ticketcontroldev.cloudfunctions.net/api/transfer`,
        // "http://127.0.0.1:5001/ticketcontroldev/us-central1/api/transfer",
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Accept: "application/json",
          },
          body: JSON.stringify(data),
        }
      );


      if (!response.ok) {
        alert(`Error HTTP: ${response.status}`);
        return;
      }

      const json = await response.json();

      setCode(json.clave_str);
      // ACÁ NO SE BANEA. El baneo de la computadora de origen lo hace el servidor
      // cuando la computadora de destino confirma que terminó (/transfer/code/success).
      //
      // Antes se baneaba justo acá, apenas se obtenía el código. En ese momento la
      // computadora nueva todavía no descargó nada: si el cliente no llega a canjear
      // el código —se le hizo tarde, la PC nueva no estaba lista, se cortó internet—
      // se queda SIN NINGUNA computadora funcionando. Y como el Desktop escribe `b001`
      // en licence.txt al detectar el baneo, desbanear no alcanza: hay que reemitirle
      // la licencia.
      showModalConfirm();
    } catch (error) {
      alert("Ha ocurrido un error. Inténtalo nuevamente.");
      console.error("Error en transferFile:", error);
    }
  };

  const showModalConfirm = () => {
    setModalConfirm(true);
  };

  const checkIfBanned = async (company_id) => {
    // Colección `baneo` de ticketcontroldev, con la KEY limpia: el baneo se mudó ahí en la
    // migración del proyecto viejo (pieza 2). La del proyecto viejo quedó congelada.
    const docRef = doc(firestore, "baneo", keyBare(company_id));
    const docSnap = await getDoc(docRef);
    const banned = docSnap.exists();
    return banned;
  };

  // Acá vivía `BannearPC`, que escribía la colección `baneo` DIRECTO desde el navegador
  // del cliente. Se eliminó por dos motivos:
  //
  //  1. Se llamaba al generar el código, antes de que la computadora nueva bajara nada
  //     (ver `transferFile`). El baneo ahora lo hace el servidor cuando el destino
  //     confirma que terminó, que es el único momento en que es seguro.
  //  2. Su `catch` hacía `setBanned(true)` igual que el camino de éxito: si la escritura
  //     fallaba, la pantalla decía que la PC había quedado baneada cuando no lo estaba.
  //
  // `checkIfBanned` se conserva: sólo LEE, para mostrar el estado.

  return (
    <>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumbs title="TicketControl" breadcrumbItem="Backups" />

          {/* Header info */}
          <div className="text-muted mb-3" style={{ fontSize: 13 }}>
            <span className="material-symbols-rounded text-primary me-2" style={{ fontSize: 20 }}>cloud_done</span>
            Copias de seguridad automáticas de tu base de datos. Puedes descargarlas o trasladarlas a otra PC en caso de cambio de equipo.
          </div>

          <div className="d-flex align-items-center mb-3">
            <span className="text-muted" style={{ fontSize: 13 }}>
              {backups.length} backup{backups.length !== 1 ? "s" : ""} disponible{backups.length !== 1 ? "s" : ""}
            </span>
          </div>

          {backups.length === 0 ? (
            <div className="text-center text-muted py-5">
              <span className="material-symbols-rounded d-block mb-3" style={{ fontSize: 48, opacity: 0.3 }}>cloud_off</span>
              No hay backups disponibles
            </div>
          ) : (
            <Row className="g-3">
              {backups.map((backup, index) => (
                <Col key={index} xs={12} sm={6} md={6} lg={4} xl={3}>
                  <Card className="shadow-sm h-100" style={{ borderLeft: "3px solid var(--bs-primary)", borderRadius: 8 }}>
                    <CardBody className="py-3 px-3">
                      <div className="d-flex align-items-center mb-2">
                        <span className="material-symbols-rounded text-primary me-2" style={{ fontSize: 20 }}>folder_zip</span>
                        <Badge color="primary" style={{ fontSize: 12 }}>{formatDate(backup)}</Badge>
                      </div>
                      <div className="text-muted mb-3" style={{ fontSize: 11, wordBreak: "break-all" }}>
                        {backup}
                      </div>
                      <div className="d-flex flex-wrap gap-2">
                        <Button
                          color="primary"
                          size="sm"
                          onClick={() => downloadBackup(backup)}
                        >
                          <span className="material-symbols-rounded me-1" style={{ fontSize: 16 }}>download</span>Descargar
                        </Button>
                        {!banned && (
                          <Button
                            color="info"
                            size="sm"
                            outline
                            onClick={() => translateToPC_init(backup)}
                          >
                            <span className="material-symbols-rounded me-1" style={{ fontSize: 16 }}>computer</span>Trasladar
                          </Button>
                        )}
                      </div>
                    </CardBody>
                  </Card>
                </Col>
              ))}
            </Row>
          )}

          {/* Modal: Confirmar traslado */}
          <Modal isOpen={modal} toggle={toggle} centered>
            <ModalHeader toggle={toggle}>
              <span className="material-symbols-rounded me-2" style={{ fontSize: 20 }}>computer</span>
              Trasladar a otra PC
            </ModalHeader>
            <ModalBody>
              <p>
                Esta operación <strong>transferirá la Licencia y la base de datos seleccionada</strong>,
                quedando deshabilitada la PC actual para su uso con TicketControl.
              </p>
              <Alert color="warning" className="mb-0">
                <span className="material-symbols-rounded me-1" style={{ fontSize: 16 }}>warning</span>
                En caso de tener que volver a usar la PC actual, deberá solicitar a soporte técnico que habilite el acceso nuevamente.
              </Alert>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={translateToPC}>
                <span className="material-symbols-rounded me-1" style={{ fontSize: 16 }}>check</span>
                Sí, trasladar
              </Button>
              <Button color="secondary" onClick={toggle}>
                Cancelar
              </Button>
            </ModalFooter>
          </Modal>

          {/* Modal: Código de transferencia */}
          <Modal isOpen={modalConfirm} toggle={toggleConfirm} centered size="lg">
            <ModalHeader toggle={toggleConfirm}>
              <span className="material-symbols-rounded me-2 text-success" style={{ fontSize: 20 }}>check_circle</span>
              Transferencia exitosa
            </ModalHeader>
            <ModalBody>
              <div className="text-center mb-3">
                <span className="material-symbols-rounded text-primary d-block mb-2" style={{ fontSize: 48 }}>vpn_key</span>
                <div className="text-muted" style={{ fontSize: 13 }}>Código de Transferencia</div>
                <div className="text-primary" style={{ fontSize: 48, fontWeight: 700, letterSpacing: 4 }}>{code}</div>
              </div>

              <Alert color="danger">
                <span className="material-symbols-rounded me-1" style={{ fontSize: 16 }}>warning</span>
                Esta es la única vez que verás el código. Te recomendamos tomar nota o fotografía.
                Válido por las próximas <strong>24 horas</strong>.
              </Alert>

              <div className="text-muted" style={{ fontSize: 13 }}>
                <p className="mb-2"><strong>Pasos en la nueva PC:</strong></p>
                <ol className="mb-0" style={{ paddingLeft: 20 }}>
                  <li>Instala TicketControl desde <strong>www.ticketcontrol.net</strong></li>
                  <li>Ejecuta TicketControl</li>
                  <li>Haz clic en <strong>"Trasladar desde otra PC"</strong></li>
                  <li>Ingresa el código de arriba</li>
                </ol>
              </div>

              <Alert color="primary" className="mt-3 mb-0">
                <span className="material-symbols-rounded me-1" style={{ fontSize: 16 }}>info</span>
                Recuerda configurar Monitor en la nueva PC para agregar los emails nuevamente.
              </Alert>
            </ModalBody>
            <ModalFooter>
              <Button color="primary" onClick={toggleConfirm}>
                Entendido
              </Button>
            </ModalFooter>
          </Modal>
        </Container>
        {/* {JSON.stringify(props.licence)} */}
      </div>
    </>
  );
};

const mapStateToProps = (state) => {
  return {
    company_id: state.companies.currentCompany?.id,
    currentCompany: state.companies.currentCompany,
    company_name: state.companies.currentCompany?.name,
  };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(mapStateToProps, mapDispatchToProps)(Backups);
